import { Component, OnInit, Inject, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { SuiteService } from 'src/app/Services/suite.service';
import { ScenarioServiceService } from 'src/app/Services/scenario-service.service';
import { AgileStudioAuthService } from 'src/app/Services/agile-studio-auth.service';
import { JiraAuthService } from 'src/app/Services/jira-auth.service';
import { ProjectEpicMappingModel } from 'src/app/Models/project-epic-mapping-model';
import { ProjectScenarioMappingModel } from 'src/app/Models/project-scenario-mapping-model';
const emptyForm = { name: null }
const keywords = [
  "open", "openWindow", "pause", "selectFrame", "selectWindow", "close", "ajaxWait", "domWait", "type", "select", "submit", "sendKeys", "storeText", "storeValue", "verifySelectedValue", "assertText", "verifyText", "click", "click", "refresh", "break", "contextMenu", "contextMenuAt", "doubleClick", "doubleClickAt", "dragAndDrop", "dragAndDropToObject", "waitForElementPresent", "waitForSomethingSelected", "waitForVisible", "verifyChecked", "verifyEditable", "verifyElementNotPresent", "verifyElementPresent", "verifyNotEditable", "mouseMoveAt", "mouseMove", "mouseOver", "assertAlert", "chooseOkOnNextConfirmation",
  "assertPrompt", "assertConfirmation", "chooseCancelOnNextConfirmation", "answerOnNextPrompt", "abstract", "continue", "for", "new", "switch", "assert", "default", "goto*", "package", "synchronized", "boolean", "do", "if", "private", "this", "break", "double", "implements", "protected", "throw", "byte", "else", "import", "public", "throws", "case", "enum*", "instanceof", "return", "transient", "catch", "extends", "int", "short", "try", "char", "final", "interface", "static", "void", "class", "finally", "long", "strictfp**", "volatile", "const*", "float", "native", "super", "while", "Edit ", "Save As "
]
@Component({
  selector: 'ze-add-element',
  templateUrl: './add-element.component.html',
  styleUrls: ['./add-element.component.scss']
})
export class AddElementComponent implements OnInit, AfterViewInit {
  // shows whether mapping UI should be displayed; read from localStorage
  public isMapped: boolean = false;
  public options = [];
  public filteredOptions = [];
  public duplicate = false;
  public title: string;
  public Name: string;
  public buttonName: string;
  public isPasswordField = false;
  public showPassword = false;
  form: FormGroup;
  editElement;
  name: string;
  jiratitle: any;
  newWP;
  isDuplicate = false;
  isPageDuplicate: boolean = false;
  public optionsPage = [];
  public filteredOptionsPage = [];
  public jiraProjectList = [];
  jiraColumnList: string[] = [];
  jiraIssueList: any;
  jiraEpicList: any;
  selectedJiraColumn: string;
  isKeyword = false;
  isFirstChecked: boolean;
  isSecondChecked: boolean;;
  keywordsInfo: string = "Name Not Allowed :  ";
  isWithoutPMChecked: boolean = true;
  isWithPMTChecked: boolean = false;
  showNextButton: boolean = false;
  integrationAvailable: boolean = false;
  pageSize: number = 10;
  hasMoreEpics: boolean = false;
  isLoadingEpics: boolean = false;
  allFetchedEpics: any[] = []; // Store all fetched epics
  nextPageTokenEpics: string = '';
  currentIssuePage: number = 1;
  totalIssues: number = 0;
  hasMoreIssues: boolean = false;
  isLoadingIssues: boolean = false;
  selectedData: any = null;
  allFetchedIssues: any[] = []; // Store all fetched issues
  nextPageToken: string = '';
  projectEpicMappingModel: ProjectEpicMappingModel | null = null;
  projectScenarioMappingModel: ProjectScenarioMappingModel | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddElementComponent>,
    private fb: FormBuilder,
    private ref: ChangeDetectorRef,
    private router: Router,
    private suiteService: SuiteService,
    private scenarioService: ScenarioServiceService,
    private agileStudioAuthService: AgileStudioAuthService,
    private jiraAuthService: JiraAuthService,

  ) {
    this.buttonName = data.buttonName;
    this.title = data.title;
    this.jiratitle = data.jiratitle || null;
    this.isPasswordField = data.event === 'Pwd';
    this.Name = this.isPasswordField ? 'Password' : 'Name';
    this.name = data.name;
    this.options = data.list == null ? [] : data.list;
    this.filteredOptions = this.options;
    this.optionsPage = data.pageList == null ? [] : data.pageList
    this.filteredOptionsPage = this.optionsPage;
    this.isFirstChecked = this.title === 'Add Suites' || this.title === 'Add Scenario';
  }
  onPMToggleChange(event: any) {
    this.isWithPMTChecked = event.checked;
    this.isWithoutPMChecked = !event.checked;
    this.showNextButton = event.checked;
  }

  onToggle(selected: 'first' | 'second') {
    if (selected === 'first') {
      this.isFirstChecked = true;
      this.isSecondChecked = false;
    } else {
      this.isFirstChecked = false;
      this.isSecondChecked = true;
    }
  }
  listFilter(event) {
    this.validateName(event);
  }

  private isNameValidationEnabled(): boolean {
    const title = (this.title || '').toLowerCase();
    return title.includes('suite') || title.includes('feature') || title.includes('scenario') || title.includes('step') || title.includes('save as') || title.includes('save step to library');
  }

  private normalizeName(value: string): string {
    return (value || '').trim();
  }

  public validateName(value: string): boolean {
    this.isKeyword = false;
    if (!this.form) {
      return false;
    }
    if (this.isPasswordField) { return true; }

    const control = this.form.get('name');
    if (!control) {
      return false;
    }

    const trimmedValue = this.normalizeName(value);
    control.setValue(trimmedValue, { emitEvent: false });

    if (!this.isNameValidationEnabled()) {
      control.setErrors(null);
      this.isDuplicate = false;
      this.isPageDuplicate = false;
      this.isKeyword = false;
      return true;
    }

    const errors: any = {};

    if (!trimmedValue) {
      errors.required = true;
    } else {
      if (!/^[_A-Za-z][A-Za-z0-9 _-]*$/.test(trimmedValue)) {
        errors.specialCharacters = true;
      }
      if (keywords.includes(trimmedValue)) {
        errors.keyword = true;
        this.isKeyword = true;
      }

      this.filteredOptions = this._filter(trimmedValue);
      this.filteredOptionsPage = this._pageFilter(trimmedValue);
      this.isDuplicate = false;
      this.isPageDuplicate = false;

      this.filteredOptions.forEach(option => {
        if (option === trimmedValue) {
          errors.duplicate = true;
          this.isDuplicate = true;
        }
      });
      this.filteredOptionsPage.forEach(option => {
        if (option === trimmedValue) {
          errors.pageDuplicate = true;
          this.isPageDuplicate = true;
        }
      });
    }

    control.setErrors(Object.keys(errors).length ? errors : null);
    return Object.keys(errors).length === 0;
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.slice().filter(option => option.toLowerCase().includes(filterValue));
  }
  private _pageFilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.optionsPage.slice().filter(option => option.toLowerCase().includes(filterValue));
  }
  ngOnInit() {
    // Read isMapped flag from localStorage. Accept 'true' or '1' as truthy values.
    try {
      const mappedValue = localStorage.getItem('isMapped');
      this.isMapped = mappedValue === 'true' || mappedValue === '1' || !!(this.data && this.data.isMapped);
    } catch (err) {
      // In some environments (server-side rendering) localStorage may be unavailable.
      this.isMapped = !!(this.data && this.data.isMapped);
    }
     
    this.keywordsInfo += keywords.join(', ');
    this.editElement = { name: this.name };
    this.form = this.buildForm(this.editElement);
    this.ref.markForCheck();
    this.listFilter(this.name);
    this.ref.detectChanges();
    this.checkIntegrationAvailable();
  }

  ngAfterViewInit() {
    if (this.isMapped) {
      this.showList()
    }
  }

  // onSelectChange(value: any) {
  //   this.selectedData = value;
  //   console.log('Selected Data:', this.selectedData);
  // }


  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  onSelectChange(index: string) {
    if (index === 'loadMoreEpics') {
      this.loadMoreEpics();
      return;
    }

    const selectedIndex = parseInt(index, 10);

    // Retrieve the full object
    if (!isNaN(selectedIndex)) {
      this.selectedData = this.jiraEpicList[selectedIndex];
      // Update the form control value with the epic name
      const sanitizedEpicName = this.normalizeName(this.selectedData.epic_name || '');
      const epicName = sanitizedEpicName && /^[A-Za-z]/.test(sanitizedEpicName) ? sanitizedEpicName : `A${sanitizedEpicName.replace(/^[-_]+/, '')}`;
      this.form.get('name').setValue(epicName);
      this.validateName(epicName);
      
      // Create ProjectEpicMappingModel for backend
      this.projectEpicMappingModel = {
        epic_id: this.selectedData.epic_id,
        epic_key: this.selectedData.epic_key,
        epic_name: this.selectedData.epic_name,
        project_id: this.data.projectId || '', // Assuming projectId is passed in data
        suite_id: this.data.suiteId || '', // For edit scenarios, this will be set by parent
        project_management_mapping_id: '', // This will be set by the backend
        created_by: '', // Will be set by backend
        created_time: 0, // Will be set by backend
        last_updated_by: '', // Will be set by backend
        last_updated_time: 0 // Will be set by backend
      };
      
      console.log('Selected Jira Epic Object:', this.selectedData);
      console.log('ProjectEpicMappingModel:', this.projectEpicMappingModel);
    } else {
      this.selectedData = null; // in case "Select an option" is chosen
      this.projectEpicMappingModel = null;
      this.form.get('name').setValue(''); // Clear the input when no option is selected
    }
  }

  onSelectIssueChange(index: string): void {
    if (index === 'loadMoreIssues') {
      this.loadMoreIssues();
      return;
    }

    const selectedIndex = parseInt(index, 10);
    if (!isNaN(selectedIndex) && this.jiraIssueList[selectedIndex]) {
      this.selectedData = this.jiraIssueList[selectedIndex];
      // Update the form control value with the issue summary
      let sanitized = (this.selectedData.issue_summary || '').replace(/[^A-Za-z0-9_\- ]/g, '').trim();
      if (!sanitized) {
        sanitized = 'A';
      } else if (!/^[A-Za-z]/.test(sanitized)) {
        sanitized = `A${sanitized.replace(/^[-_]+/, '')}`;
      }
      this.form.get('name').setValue(sanitized);
      this.validateName(sanitized);
      
      // Create ProjectScenarioMappingModel for backend
      this.projectScenarioMappingModel = {
        issue_id: this.selectedData.issue_id,
        issue_key: this.selectedData.issue_key,
        issue_summary: this.selectedData.issue_summary,
        project_id: this.data.projectId || '', // Assuming projectId is passed in data
        scenario_id: this.data.scenarioId || '', // For edit scenarios, this will be set by parent
        project_management_mapping_id: '', // This will be set by the backend
        created_by: '', // Will be set by backend
        created_time: 0, // Will be set by backend
        last_updated_by: '', // Will be set by backend
        last_updated_time: 0 // Will be set by backend
      };
      
      console.log('Selected Data:', this.selectedData);  // ✅ Debug
      console.log('ProjectScenarioMappingModel:', this.projectScenarioMappingModel);
    } else {
      this.selectedData = null;
      this.projectScenarioMappingModel = null;
      this.form.get('name').setValue(''); // Clear the input when no option is selected
      console.warn('Invalid index or missing data for Jira issue.');
    }
  }


  checkIntegrationAvailable() {
    this.agileStudioAuthService.isAgileStudioIntegrationAvailable().subscribe((data: any) => {
      console.log('Agile Studio Integration Available:', data.data);
      if (data.data) {
        this.integrationAvailable = true;
      }
    })
    this.jiraAuthService.isJiraIntegrationAvailable().subscribe((data: any) => {
      if (data.data) {
        this.integrationAvailable = true;
      }
      console.log('Jira Integration Available:', data.data);
    })
  }


  showList() {
    if (!this.isMapped) {
      return;
    }
    if (this.title === 'Add Scenario' || this.title === 'Edit Scenario') {
      // Reset state when loading fresh
      this.allFetchedIssues = [];
      this.jiraIssueList = [];
      this.nextPageToken = '';
      this.loadIssues('');
    }
    if (this.title === 'Add Suites' || this.title === 'Edit Suites') {
      // Reset state when loading fresh
      this.allFetchedEpics = [];
      this.jiraEpicList = [];
      this.nextPageTokenEpics = '';
      this.loadEpics('');
    }
  }

  loadEpics(nextPageToken: string = '') {
    if (this.isLoadingEpics) return;

    this.isLoadingEpics = true;

    this.suiteService.getJiraEpicList(this.pageSize, nextPageToken).subscribe((data: any) => {
      console.log('Jira Epic List:', data.data.epics);
      const epics = data.data.epics || [];
      
      // Add new epics to the allFetchedEpics array
      this.allFetchedEpics = this.allFetchedEpics.concat(epics);
      
      // Update pagination info
      this.hasMoreEpics = data.data.hasNextPage || false;
      this.nextPageTokenEpics = data.data.nextPageToken || '';
      
      // Update jiraEpicList to show all fetched epics
      this.jiraEpicList = this.allFetchedEpics.slice();
      
      this.isLoadingEpics = false;
      this.ref.detectChanges();
    }, error => {
      console.error('Error loading epics:', error);
      this.isLoadingEpics = false;
      this.ref.detectChanges();
    });
  }

  loadIssues(nextPageToken: string = '') {
    if (this.isLoadingIssues) return;

    this.isLoadingIssues = true;

    this.scenarioService.getJiraIssueList(this.pageSize, nextPageToken).subscribe((data: any) => {
      console.log('Jira Issue List:', data.data.issues);
      const issues = data.data.issues || [];
      
      // Add new issues to the allFetchedIssues array
      this.allFetchedIssues = this.allFetchedIssues.concat(issues);
      
      // Update pagination info
      this.hasMoreIssues = data.data.hasNext || false;
      this.nextPageToken = data.data.nextPageToken || '';
      
      // Update jiraIssueList to show all fetched issues
      this.jiraIssueList = this.allFetchedIssues.slice();
      
      this.isLoadingIssues = false;
      this.ref.detectChanges();
    }, error => {
      console.error('Error loading issues:', error);
      this.isLoadingIssues = false;
      this.ref.detectChanges();
    });
  }

  loadMoreEpics() {
    if (this.hasMoreEpics && !this.isLoadingEpics && this.nextPageTokenEpics) {
      this.loadEpics(this.nextPageTokenEpics);
    }
  }

  loadMoreIssues() {
    if (this.hasMoreIssues && !this.isLoadingIssues && this.nextPageToken) {
      this.loadIssues(this.nextPageToken);
    }
  }

  buildForm(element: any = emptyForm): FormGroup {
    const form: FormGroup = this.fb.group({
      name: new FormControl(element.name, Validators.required)
    })
    return form;
  }
  openNewTab() {
    const newTabUrl = window.location.origin + '/assets/Term-Restrictions.html';
    window.open(newTabUrl, '_blank');
  }
  getErrorMessage() {
    return "name is required";
  }
  // onSubmit(): void {
  //   if (!this.form.valid) {
  //     return;
  //   }
  //   this.dialogRef.close(this.form.value);
  // }

  onSubmit(): void {
    const trimmedName = this.normalizeName(this.form.get('name').value);
    this.form.get('name').setValue(trimmedName, { emitEvent: false });

    if (!this.validateName(trimmedName) || !this.form.valid) {
      this.form.get('name').markAsTouched();
      this.form.get('name').setErrors({ ...this.form.get('name').errors, invalidName: true });
      return;
    }
    const formValue = {
      ...this.form.value,
      name: trimmedName
    };

    // Combine form value and selected dropdown value
    const result = {
      ...formValue,
      selectedData: this.selectedData,
      projectEpicMappingModel: this.projectEpicMappingModel,
      projectScenarioMappingModel: this.projectScenarioMappingModel
    };
    console.log("Selected Data:", result.selectedData); // ✔️
    console.log("ProjectEpicMappingModel:", result.projectEpicMappingModel); // ✔️
    console.log("ProjectScenarioMappingModel:", result.projectScenarioMappingModel); // ✔️

    this.dialogRef.close(result);
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
  toggleWithoutPM() {
    if (!this.isWithoutPMChecked) {
      this.isWithoutPMChecked = true;
      this.isWithPMTChecked = false;
      this.showNextButton = false;
    }
  }
  toggleWithPMT() {
    if (!this.isWithPMTChecked) {
      this.isWithPMTChecked = true;
      this.isWithoutPMChecked = false;
      this.showNextButton = true;
    }
  }
  onNextClick() {
    this.router.navigate(['/map']).then(() => {
      this.dialogRef.close();
    });
  }
}


